import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { BASE_URL_API } from '../../References/url';
import AuthContext from '../../Store/auth-context';
import styles from './ELPDSBulkActions.module.css';

const ELPDSBulkActions = (props) => {
    const { isOpen, onClose, selectedData } = props;
    const authCtx = useContext(AuthContext)
    const [isUpdating, setIsUpdating] = useState(false)

    const [selectedEntities, setSelectedEntities] = useState({
        user: { subType: '', entity: null },
        product: { subType: '', entity: null },
        internal: { subType: '', entity: null }
    });

    const headerOptions = [
        { label: "User", value: "user" },
        { label: "Product", value: "product" },
        { label: "Internal Team", value: "internal" }
    ];

    const subTypeOptions = {
        user: [
            { label: "Distributor", value: "distributor" },
            { label: "Retailer", value: "retailer" },
            { label: "End User", value: "end_user" }
        ],
        internal: [
            { label: "Sales Head", value: "sales_head" },
            { label: "Regional Head", value: "regional_head" },
            { label: "Sales Executive", value: "sales_exec" }
        ],
        product: [
            { label: "Product A", value: "prod_a" },
            { label: "Product B", value: "prod_b" }
        ]
    };

    const [entityList, setEntityList] = useState({
        distributor: [
            { userIdentifier: "U1", userLabel: "Distributor 1" },
            { userIdentifier: "U2", userLabel: "Distributor 2" }
        ],
        retailer: [
            { userIdentifier: "U3", userLabel: "Retailer 1" },
            { userIdentifier: "U4", userLabel: "Retailer 2" }
        ],
        sales_head: [
            { designationIdentifier: "SH1", designationLabel: "Sales Head A" }
        ],
        prod_a: [
            { productIdentifier: "P1", productLabel: "Product A1" }
        ]
    })

    const handleSubTypeChange = (header, newSubType) => {
        setSelectedEntities(prev => ({
            ...prev,
            [header]: {
                subType: newSubType,
                entity: null
            }
        }));
    };

    const handleEntityChange = (header, value) => {
        const selected = entityList[selectedEntities[header].subType]?.find(
            item =>
                item.userIdentifier === value ||
                item.productIdentifier === value ||
                item.designationIdentifier === value
        );
        setSelectedEntities(prev => ({
            ...prev,
            [header]: {
                ...prev[header],
                entity: selected
            }
        }));
    };


    function generateEntityList(data) {
        const entityList = {};

        data.forEach((user) => {
            const designation = user.designation?.trim();
            const userIdentifier = user.userIdentifier?.trim();

            // Skip if designation is missing, empty, or null
            if (!designation) return;

            // Skip if userIdentifier is missing
            if (!userIdentifier) return;

            if (!entityList[designation]) {
                entityList[designation] = [];
            }

            // Combine firstName, middleName, and lastName
            const firstName = user.firstName?.trim() || '';
            const middleName = user.middleName?.trim() || '';
            const lastName = user.lastName?.trim() || '';

            // Assemble full name
            const fullName = [firstName, middleName, lastName]
                .filter(Boolean) // Remove empty parts
                .join(' ')
                .trim();

            // If even fullName is empty, fallback to "Unknown"
            const userLabel = fullName || 'Unknown';

            entityList[designation].push({
                userIdentifier,
                userLabel
            });
        });

        return entityList;
    }


    console.log("entityList from backend  : ", entityList)

    const getAllUsers = async () => {
        const response = await fetch(BASE_URL_API + "/getAllUsers",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    clientIdentifier: authCtx.clientIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Errro")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setEntityList(generateEntityList(respo?.response))
            } else {
                if (respo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
                setEntityList({
                    distributor: [],
                    retailer: [],
                    sales_head: [],
                    prod_a: []
                })
            }
            console.log(respo)
        }
    }

    useEffect(() => {
        getAllUsers()
    }, [])


    const handleApply = async () => {
        const allSelected = Object.values(selectedEntities).filter(v => v.entity);
        if (allSelected.length === 0) return alert("Please select at least one entity");
        setIsUpdating(true)
        console.log("Apply bulk mapping to: ", selectedEntities);
        // console.log("For selected codes: ", selectedData);
        // onClose();

        const response = await fetch(BASE_URL_API + "/updateBoosterCodesMappingStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    codesData: selectedData,
                    selectedEntities: selectedEntities
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                toast(`Successfully mapped the QR Codes!`)
                onClose()
            } else {
                if (respo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
                console.log(respo)
            }
        }
        setIsUpdating(false)
    };

    if (!isOpen) return null;

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                <div className={styles.mainContent}>
                    <div className={styles.titleWrapper}>
                        <div className={styles.title}>Bulk Action - Map {selectedData.length} codes To</div>
                    </div>

                    <div className={styles.headerWrapper}>
                        {headerOptions.map(header => (
                            <div key={header.value} className={styles.headerSection}>
                                <h4>{header.label}</h4>

                                <div className={styles.field}>
                                    <label>Sub Type</label>
                                    <select
                                        value={selectedEntities[header.value].subType}
                                        onChange={e => handleSubTypeChange(header.value, e.target.value)}
                                    >
                                        <option value="">Select Type</option>
                                        {(subTypeOptions[header.value] || []).map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                </div>

                                {selectedEntities[header.value].subType && (
                                    <div className={styles.field}>
                                        <label>Select Entity</label>
                                        <select
                                            value={
                                                selectedEntities[header.value].entity?.userIdentifier ||
                                                selectedEntities[header.value].entity?.productIdentifier ||
                                                selectedEntities[header.value].entity?.designationIdentifier ||
                                                ""
                                            }
                                            onChange={e => handleEntityChange(header.value, e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {(entityList[selectedEntities[header.value].subType] || []).map(item => {
                                                const id = item.userIdentifier || item.productIdentifier || item.designationIdentifier;
                                                const label = item.userLabel || item.productLabel || item.designationLabel;
                                                return (
                                                    <option key={id} value={id}>{label}</option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className={styles.actionWrapper}>
                        <div className={styles.actions}>
                            {isUpdating === true ?
                                <button disabled>Applying...</button>
                                :
                                <button onClick={handleApply}>Apply</button>
                            }
                            <button onClick={onClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ELPDSBulkActions;
